import {
    GetPersonalPhoneNumbersQuery,
    useGetPersonalPhoneNumbersQuery,
} from "generated/graphql";
import { useMemo } from "react";
import { stableQueryOptions } from "util/requests";

const fiveMinutes = 5 * 60 * 1000;

export const usePhoneLines =
    (): GetPersonalPhoneNumbersQuery["getPersonalPhoneNumbers"] => {
        const getPersonalNumbers = useGetPersonalPhoneNumbersQuery(
            {},
            {
                ...stableQueryOptions(),
                refetchInterval: fiveMinutes,
            },
        );

        const sendingNumbers = useMemo(() => {
            return getPersonalNumbers.data?.getPersonalPhoneNumbers ?? [];
        }, [getPersonalNumbers.data]);

        return sendingNumbers;
    };
